import { render, staticRenderFns } from "./indexTable.vue?vue&type=template&id=8f56080e&scoped=true"
import script from "./indexTable.vue?vue&type=script&lang=js"
export * from "./indexTable.vue?vue&type=script&lang=js"
import style0 from "./indexTable.vue?vue&type=style&index=0&id=8f56080e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f56080e",
  null
  
)

export default component.exports